import { render } from "./Step3.vue?vue&type=template&id=64ce1f80&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"

import "./Step3.vue?vue&type=style&index=0&id=64ce1f80&scoped=true&lang=css"

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ce1f80"]])

export default __exports__